import { Col, Row } from 'reactstrap';
import GetYourPostBase from './GetYourPostBase';
import Const from '../../components/Const';
import Send from '../../images/send-white.png';
import { getInitAItextAreaHeight, getAIsendArrowHeight, setAItextAreaHeight,
         setAItextAreaOpacity, getAItextAreaHeight, setAIsendArrowOpacity } from '../../utils/AIUtils.js';
import { addOrientationChangeListener, removeOrientationChangeListener } from '../../utils/SessionUtils.js';
import { isiPhone } from '../../utils/AppUtils.js';
import { getBottomBarMobil, getFakeAIinput } from '../../utils/PostUtils.js';

export default class GetYourPostMobile extends GetYourPostBase {
  constructor(props) {
    super(props);

    this.DEFAULT_HEIGHT = 80; // 5rem 
    this.MIN_HEIGHT = 24; 
    this.SMALL_TIMEOUT = 300;
    this.AItextareaHeightNoKeyBoard = getInitAItextAreaHeight();
    this.AItextareaHeightWithKeyBoard = 0;
    this.AIsendArrowHeight = getAIsendArrowHeight();
    this.state.aiInputClassName = "";
    this.state.isKeyboardUp = false;
    this.state.hide = false;
    this.bigTextAreaIsMeasured = false;
    this.fullVisualViewportHeight = 0;
    this.imageUploadBlocker = false;
    this.onBlurHandler = this.onBlurHandler.bind(this);
    this.blurEnabled = false;
  }

  componentDidMount() {
    this.startPostProcess();
  }

  componentDidUpdate() {
		// This is needed because of transition from AI input screen with keyboard to main AI screen without it.
		// When  disableAIinput() is called in the begining of AI request we can still be in AI input screen, where 
		// not all main AI screen elements are available, so here we disable them when we are in main AI screen.
		if (!this.state.submitToAINotSentYet) {
			this.disableAIinput(true, false);
		}
	}

  observeOrientationChange(toggleModal) {
		if (toggleModal) {
			// pop-up is window is about to pop up
			addOrientationChangeListener(this);
		}
	}

	orientationChangeProcessor() {
		this.toggle();
		this.state.parent.setState({ orientationChanged : true }); // nav will change the '+' button content
		removeOrientationChangeListener();
	}

  setStateAttributes() {
    if (this.state.modal) {
      // Post modal pop-up is closing
      if (this.timeoutID !== -1) {
        clearTimeout(this.timeoutID);
      }
      this.timeoutID = setTimeout(this.activateAddPostButton, Const.MOBIL_BUTTON_ACTIVATION_DELAY, this);
    }
  }

  activateAddPostButton(that) {
    let parent = that.state.parent;

    if (parent.mounted) {
      // parent is Nav, if parent.mounted is false, the button will be reactivated in its constructed
      if (parent && parent.hasOwnProperty('state') && 
          parent.state.hasOwnProperty('showMobilButton') && !parent.state.showMobilButton) {
          parent.setState({ showMobilButton : true, showModalPopUp : false });
      }
    }
    clearTimeout(this.timeoutID);
  }

  handleFakeInputTouch = () => {
    let stateObj = {
      isKeyboardUp : true, 
      AIpostUserNameHeader : '',  
      postUserNameHeader : '', 
      backgroundImageClass : this.BACKGROUND_IMAGE_CLASS_NO_IMAGE
    };

    this.AIvideoLayoutToggle = false;
    if (!this.bigTextAreaIsMeasured) {
      window.visualViewport?.addEventListener('resize', () => this.setAiMobilInputHeight(true), { once: true });
      stateObj.hide = false;
      setAIsendArrowOpacity(0.01);
      setAItextAreaOpacity(0.01);
      this.getAIinputFocusOnStateChange(stateObj);
    }
    else {
      this.setCalculatedAiMobilInputHeight(stateObj);
    }
  }

  getAIinputFocusOnStateChange(stateObj) {
    let input;

    if (isiPhone()) {
      this.setState(stateObj); // focus is already set by Autofocus on IPhone
    }
    else {
      this.setState(stateObj, () => {
        setTimeout(() => {
          input = document.getElementById("aiInput");
          if (input) {
            input.focus();
          }
        }, this.SMALL_TIMEOUT);
      });
    }
  }

  setCalculatedAiMobilInputHeight(stateObj) {
    this.setState(stateObj);
    if (isiPhone()) {
      // this prvenets the keybopard push up the content (Android is fine)
      window.visualViewport?.addEventListener('resize', () => {
        setAItextAreaHeight(this.AItextareaHeightWithKeyBoard);
        this.blurEnabled = true;
      }, { once: true });
    }
    else {
      this.setState(stateObj);
      setAItextAreaHeight(this.AItextareaHeightWithKeyBoard);
      this.blurEnabled = true;
    }
  }

  onBlurHandler = () =>  {  
    if (!this.blurEnabled) {
      // Ignore fake blur caused by keyboard animation
      return;
    }
    this.AIvideoLayoutToggle = true;
     window.visualViewport?.addEventListener('resize', () => {
        setAItextAreaHeight(this.AItextareaHeightNoKeyBoard);
        this.setState(
                    { 
                      isKeyboardUp : false, 
                      AIpostUserNameHeader : this.AI_POST_USER_NAME_HEADER, 
                      postUserNameHeader  : this.POST_USER_NAME_HEADER, 
                      // button2 can be active when we are in the 2nd AI screen and go to create my post
                      backgroundImageClass : (this.state.activeButton === 'button1') ? this.BACKGROUND_IMAGE_CLASS
                                                                                     : this.BACKGROUND_IMAGE_CLASS_NO_IMAGE
                    });
      }, { once: true })
    this.blurEnabled = false;
  }

  setAiMobilInputHeight(isCalculateHeight) {
    let aiBody = document.getElementById('aiBody');
    let rect;
    let aiInputHeight = getAItextAreaHeight();
    let savePadding = 4;

    if (isCalculateHeight) {
      rect = aiBody.getBoundingClientRect();
      aiInputHeight = window.visualViewport.height - (rect.bottom - aiInputHeight) - savePadding;
      if (aiInputHeight <= this.MIN_HEIGHT) {
        aiInputHeight = this.DEFAULT_HEIGHT;
      }
    }
    else {
      aiInputHeight = this.DEFAULT_HEIGHT;
    }
    setAItextAreaHeight(aiInputHeight);
    setAItextAreaOpacity(1);
    setAIsendArrowOpacity(1);
    this.AItextareaHeightWithKeyBoard = aiInputHeight;
    this.bigTextAreaIsMeasured = true;
    this.blurEnabled = true;
  }

  getHeader() {
    return "Create Post";
  }
  
  getBottomBar(charCounter) {
    return getBottomBarMobil(charCounter, this); // needed because tablets use getBottomBarMobil()
  }

  handleUploadImageClick = (e) => {
    if (this.imageUploadBlocker) {
      e.preventDefault();
    }
  }

  handleGetToAIButtonClick() {
    let button1StateObj = { 
          activeButton : 'button1',
          borderAI : this.BOLD_COLORED_BORDER, 
          fontWeightAI : this.BOLD_FONT, 
          borderUser : this.BOLD_BORDER,
          fontWeightUser : this.LIGHT_FONT, 
          backgroundImageClass : this.BACKGROUND_IMAGE_CLASS
      };

      this.imageUploadBlocker = true; 
      // getting to AI concierge from Create My Post (at this time keyboard is almost always up, so TIMEOUT is used)
      setTimeout(() => {
        this.setState( button1StateObj );
        this.imageUploadBlocker = false;
      }, this.TIMEOUT);
  }

  // AI concierge

  getProfileInfo(disabledAI) {
    if (!this.state.isKeyboardUp)  {
      return this.getProfileInfoDiv(disabledAI);
    }
  }

  getRadioButtons(disabledAI) {
    if (!this.state.isKeyboardUp) {
      return this.getRadioButtonsColumn(disabledAI);
    }
  }

  getAIinput() {
    let loginUser = this.state.grandParent.state.loginUser;
    let isKeyboardUp = this.state.isKeyboardUp;
    let aiLimitCond;

    if (
        this.state.AIrequestOption === this.AI_IMAGE_CREATE ||
        this.state.AIrequestOption === this.AI_POST_ILLUSTRATE ||
        this.state.AIrequestOption === this.AI_POST_VIDEO_ILLUSTRATE
    ) {
        aiLimitCond = this.aiImageLimitCondition(loginUser);
    } else {
        aiLimitCond = this.aiPostLimitCondition(loginUser);
    }
    
    // -----------------------------
    // CASE 1: Keyboard is up → show REAL INPUT
    // -----------------------------
    if (isKeyboardUp) {
        return (
            <div id="aiInputContainer" className="apr-0">
                <textarea 
                    id="aiInput" 
                    name="aiRequestTool"
                    onChange={this.handleAIinputChange}
                    autoFocus={true}
                    autoCorrect="ON"
                    maxLength={this.AI_INPUT_MAX_LEN}
                    placeholder={this.state.AIrequestPlaceHolder}
                    value={this.state.messageForAI} 
                    onBlur={() => this.onBlurHandler()}
                    disabled={!aiLimitCond || !this.state.submitToAINotSentYet}
                    className="x-input ai-textarea-mobile-n"
                />
            </div>
        );
    }
    // -----------------------------
    // CASE 2: Keyboard is DOWN → show FAKE INPUT
    // -----------------------------
        return getFakeAIinput(this);
  }

  getAIarrowButton(messageForAI, submitToAINotSentYet) {
    if (this.state.isKeyboardUp) {
      if (this.state.hide) {
        // keep hiden till keyboard is completely up
        return null;
      }
      else {
        return (
          messageForAI && submitToAINotSentYet 
          ? <Col lg={1} xs={12} className="p-0 btn-look" onClick={ this.handleSubmitToAI }>
              <div id='sendArrow' className="send" >
                <img src={ Send } className="pointer-view" alt="Avatar" />
              </div>
            </Col>
          : <Col lg={1} xs={12} className="p-0 btn-look">
              <div id='sendArrow' className="send">
                <img src={ Send } style = { this.LIGHT_FONT } alt="Avatar" />	
              </div>
            </Col>
        );
      }
    }
    else {
      return null;
    }
  }

  getNumberOfAIRequestsLeftPhone(numberOfAIRequestsLeft, remainingRequestText) {
    let adjustedRemainingRequestText ;
	
    if (!this.state.isKeyboardUp) {
      adjustedRemainingRequestText = this.adjustMarketPlaceCustomerText(numberOfAIRequestsLeft, remainingRequestText);
      return (
        <Row>
          <p id="remainingAIrequests" className="try">{ numberOfAIRequestsLeft + adjustedRemainingRequestText }</p> 	
        </Row>
      )
    }
    else {
      return null;
    }
  }

  noVirtualKeybardAfterDalleImage() {
    this.setState({ autoFocus : false });
  }
}